export const LANGUAGES_SUPPORTED = {
    English: 'en',
    Vietnamese: 'vi'
} as const;

export type LanguagesSupported = (typeof LANGUAGES_SUPPORTED)[keyof typeof LANGUAGES_SUPPORTED];

export const STATUS = {
    Inactive: 0,
    Active: 1,
    WaitConfirm: 2
} as const;

export type Status = (typeof STATUS)[keyof typeof STATUS];

export const GENDER = {
    Male: 0,
    Female: 1
} as const;

export type Gender = (typeof GENDER)[keyof typeof GENDER];

export const SHOP_STATUS_TYPE = {
    Active: 1,
    Inactive: 2,
    NotCompletedInfo: 3,
    WaitApprove: 4,
    DeniedApprove: 5
} as const;

export type ShopStatusType = (typeof SHOP_STATUS_TYPE)[keyof typeof SHOP_STATUS_TYPE];

export const SHOP_CATEGORY_TYPE = {
    PetShop: 1,
    PetHospital: 2,
    Retail: 3
} as const;

export type ShopCategoryType = (typeof SHOP_CATEGORY_TYPE)[keyof typeof SHOP_CATEGORY_TYPE];

export const SHOP_RATING_TYPE = {
    FiveStars: 5,
    FourStarsAndUp: 4,
    ThreeStarsAndUp: 3,
    TwoStarsAndUp: 2,
    OneStarAndUp: 1,
    NoReview: 0
} as const;

export type ShopRatingType = (typeof SHOP_RATING_TYPE)[keyof typeof SHOP_RATING_TYPE];

export const USER_STATUS_TYPE = {
    Active: 1,
    Inactive: 2
} as const;

export type UserStatusType = (typeof USER_STATUS_TYPE)[keyof typeof USER_STATUS_TYPE];

export const USER_ROLE_TYPE = {
    Admin: 1,
    Enduser: 2
} as const;

export type UserRoleType = (typeof USER_ROLE_TYPE)[keyof typeof USER_ROLE_TYPE];

export const GENERAL_SETTING_TYPE = {
    AboutUs: 'about_us',
    MiaPolicy: 'company_policy',
    PrivacyPolicy: 'privacy_policy'
} as const;

export type GeneralSettingType = (typeof GENERAL_SETTING_TYPE)[keyof typeof GENERAL_SETTING_TYPE];

export const SHOP_OWNER_TYPE = {
    SelectUser: 1,
    NewUser: 2
} as const;

export type ShopOwnerType = (typeof SHOP_OWNER_TYPE)[keyof typeof SHOP_OWNER_TYPE];

export const REPRESENTATIVE_ROLE_TYPE = {
    ShopOwner: 1,
    Doctor: 2,
    Manager: 3,
    Staff: 4
} as const;

export type RepresentativeRoleType = (typeof REPRESENTATIVE_ROLE_TYPE)[keyof typeof REPRESENTATIVE_ROLE_TYPE];

export const INFO_TYPE = {
    GeneralInfo: 'generalInfo',
    ShopInfo: 'shopInfo',
    OperationInfo: 'operationInfo',
    AppointmentInfo: 'appointmentInfo'
} as const;

export type InfoType = (typeof INFO_TYPE)[keyof typeof INFO_TYPE];

export const SHOP_SERVICE_NAME_TYPE = {
    Cut: 1,
    Shower: 2,
    Combo: 3,
    Hotel: 4
} as const;

export type ShopServiceNameType = (typeof SHOP_SERVICE_NAME_TYPE)[keyof typeof SHOP_SERVICE_NAME_TYPE];

export const SHOP_SERVICE_TYPE = {
    Dog: 1,
    Cat: 2,
    Medical: 3,
    Other: 4,
    Additional: 5
} as const;

export type ShopServiceType = (typeof SHOP_SERVICE_TYPE)[keyof typeof SHOP_SERVICE_TYPE];

export const ENDUSER_TYPE = {
    PetOwner: 1,
    ShopOwner: 2
} as const;

export type EnduserType = (typeof ENDUSER_TYPE)[keyof typeof ENDUSER_TYPE];

export const DAYS_OF_WEEK_TYPE = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 0
} as const;

export type DaysOfWeekType = (typeof DAYS_OF_WEEK_TYPE)[keyof typeof DAYS_OF_WEEK_TYPE];

export const PICK_UP_PRICE_TYPE = {
    Free: 1,
    ChargeByDistance: 2
} as const;

export type PickUpPriceType = (typeof PICK_UP_PRICE_TYPE)[keyof typeof PICK_UP_PRICE_TYPE];

export const APPOINTMENT_STATUS_TYPE = {
    NotConfirmed: 1,
    Confirmed: 2,
    Completed: 3,
    Cancelled: 4
} as const;

export type AppointmentStatusType = (typeof APPOINTMENT_STATUS_TYPE)[keyof typeof APPOINTMENT_STATUS_TYPE];

export const PET_TYPE = {
    Dog: 1,
    Cat: 2,
    Other: 3
} as const;

export type PetType = (typeof PET_TYPE)[keyof typeof PET_TYPE];

export const APPOINTMENT_CANCELLED_BY_TYPE = {
    PetOwner: 2,
    ShopOwner: 3
} as const;
export type AppointmentRoleType = (typeof APPOINTMENT_CANCELLED_BY_TYPE)[keyof typeof APPOINTMENT_CANCELLED_BY_TYPE];

export const REVIEW_STATUS_TYPE = {
    Published: 1,
    RequestApproval: 2,
    SeedingComments: 3
} as const;

export type ReviewStatusType = (typeof REVIEW_STATUS_TYPE)[keyof typeof REVIEW_STATUS_TYPE];

export const FORUM_TYPE = {
    FreeTopic: 1,
    Career: 2
} as const;

export type ForumType = (typeof FORUM_TYPE)[keyof typeof FORUM_TYPE];

export const TOPIC_TYPE = {
    Notice: 1,
    Advertisement: 2,
    None: 3
} as const;

export type TopicType = (typeof TOPIC_TYPE)[keyof typeof TOPIC_TYPE];

export const TOPIC_STATUS_TYPE = {
    Published: 1,
    NotPublished: 2,
    WaitingToApprove: 3,
    Rejected: 4
};

export type TopicStatusType = (typeof TOPIC_STATUS_TYPE)[keyof typeof TOPIC_STATUS_TYPE];

export const TOPIC_TYPE_APPROVE = {
    APPROVE: 'approve_topic',
    REJECT: 'reject_topic',
    RE_PUBLIC: 're_public'
};

export type TopicTypeApprove = (typeof TOPIC_TYPE_APPROVE)[keyof typeof TOPIC_TYPE_APPROVE];

export const TOPIC_CREATOR_TYPE = {
    Admin: 1,
    Enduser: 2
};

export const NEWS_CATEGORY_TYPE = {
    DogCareAndKnowledge: 1,
    CatCareAndKnowledge: 2,
    VeterinaryGuidesAndExperiences: 3
} as const;

export type NewsCategoryType = (typeof NEWS_CATEGORY_TYPE)[keyof typeof NEWS_CATEGORY_TYPE];

export const NEWS_STATUS_TYPE = {
    Published: 1,
    NotPublished: 2
} as const;

export type NewsStatusType = (typeof NEWS_STATUS_TYPE)[keyof typeof NEWS_STATUS_TYPE];

export const MONTH_OF_YEAR_TYPE = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12
} as const;

export type MonthOfYearType = (typeof MONTH_OF_YEAR_TYPE)[keyof typeof MONTH_OF_YEAR_TYPE];
